import { FC, ReactNode } from "react";

import { ReactComponent as QuotesIcon } from "../../../icons/QuotesIcon.svg";

const HomeTestimonials = () => {
  return (
    <section className="px-[20px] py-[40px]">
      <div>
        {/* Heading */}
        <div className="mb-[40px] text-center">
          <p className="text-[16px] font-open-sans font-bold text-primaryDark-0 leading-loose mb-[8px]">
            Testimonials
          </p>

          <h4 className="text-[24px] font-raleway font-bold text-primaryDark-0 leading-tight">
            <span className="text-primaryDark-400"> Hear From </span> Our
            Customers
          </h4>
        </div>

        {/* Cards */}
        <HomeTestimonialsGrid />
      </div>
    </section>
  );
};

const HomeTestimonialsGrid = () => {
  return (
    <div className="grid grid-cols-1 gap-[24px]">
      {/* Card One */}
      <HomeTestimonialsCard
        description={
          <>
            While I could have gone and found rental kitchens to work with,
            Tayana & Hassan at HomeCook provided a service that ensured that I
            could run a food business successfully.
          </>
        }
        name="Jon Chung"
        businessName="bang'n you"
      />

      {/* Card Two */}
      <HomeTestimonialsCard
        description={
          <>
            Not only have they been dedicated to helping me find a new location
            for our granola manufacturing company, but I can feel that they
            genuinely want to see me succeed.
          </>
        }
        name="Stephanie Williams"
        businessName="Oh-Mazing Food"
      />
    </div>
  );
};

type HomeTestimonialsCardProps = {
  description: ReactNode;
  name: string;
  businessName: string;
};

const HomeTestimonialsCard: FC<HomeTestimonialsCardProps> = ({
  description,
  name,
  businessName,
}) => {
  return (
    <div className="bg-primaryDark-0 rounded-[8px] shadow-md shadow-text-0/24">
      {/* Icon Box */}
      <div className="w-[80px] h-[64px] mb-[16px] bg-text-1000 flex items-center justify-center rounded-br-[56px]">
        <QuotesIcon className="w-[32px] h-[32px] text-primaryDark-400" />
      </div>

      {/* Text Box */}
      <div className="p-[30px] pt-[0px]">
        <p className="text-[16px] font-open-sans font-semibold text-text-1000 leading-loose mb-[24px]">
          {description}
        </p>

        <div>
          <h5 className="text-[20px] font-raleway font-semibold text-text-1000 leading-tight mb-[8px]">
            {name}
          </h5>
          <p className="text-[18px] font-open-sans font-semibold text-text-1000 leading-loose">
            {businessName}
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomeTestimonials;
